export const POWER_BI_TOKEN_ENDPOINTS = {
   GET_ACCESS_TOKEN: () => '/power-bi/access-token',
   GET_USER_TOKENS: () => '/power-bi/user-tokens',
};
